

import { computed, defineComponent, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import Dropdown from 'primevue/dropdown';
import CatalogTypeConst from '../../../../../catalog/domain/const/CatalogTypeConst';
import helperCatalog from '../../../../../catalog/infrastructure/helper/helperCatalog';
import { Container } from 'inversify';
import { IServiceSearch } from '../../../../../search/application/IServiceSearch';
import { TYPES } from '../../../../../../../common/domain/types';
import HelperLoading from '../../../../../../../common/infrastructure/funciones/HelperLoading';
import CatalogDbType from '../../../../../catalog/domain/const/CatalogDbType';
import HelperCommon from '../../../../../../../common/infrastructure/funciones/HelperCommon';
import debounce from 'lodash.debounce';
import HelperCustomComponentControls from '../../../functions/helperCustomComponentControls';
import MessageNodeConst from '../constants/MessageNodeConst';
import Textarea from 'primevue/textarea';
import ConditionNodeConst from '../constants/ConditionNodeConst';
//import PrimeVue from "primevue/config";
export default defineComponent({
    name: 'customconditioncontrol',
    components: {
        Dropdown,
        Textarea,
        //PrimeVue
    },
    props: {
        data: Object
    },
    setup(props) {
        const { showExpression } = HelperCustomComponentControls(props.data);


        const selectedText = ref('');


        let debounceUpdateData: any;
        const debounceTime = 1200;



        const initDebounce = () => {
            debounceUpdateData = debounce((data: any, start: boolean = false) => {
                if (props.data) {
                    props.data.onChange({ key: ConditionNodeConst.VAR_COND_IN, data: selectedText.value })
                }
            }, debounceTime);
        }

        watch(
            selectedText, (newvalue, oldvalue) => {
                if (oldvalue !== newvalue && oldvalue !== undefined) {
                    debounceUpdateData(newvalue, true);
                }
            },
            {
                flush: 'post',
                //immediate: true, 
                deep: true
            }
        )


        onMounted(() => {
            if (props.data) {
                selectedText.value = props.data.variableConditionInput
            }
            initDebounce();
        })


        onBeforeUnmount(() => {
            debounceUpdateData.cancel();
        })

        return {
            showExpression,
            ConditionNodeConst,
            selectedText
        };
    },
});
